export default "__VITE_ASSET__DI38mzWd__"